module.exports = __webpack_public_path__ + "img/apache-couchdb-logo.defd5cb1.png";